import {EntityType, GlobalKeyVault} from "./Model";
import {arrayResource, EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import {keyVaultSubscription} from "./KeyVaultStore";
import {GlobalKeyVaults_Read} from "../util/access/Permission";

export const useGlobalKeyVaultStore = create<EntityStore<GlobalKeyVault[]>>()(
    arrayResource<GlobalKeyVault, EntityStore<GlobalKeyVault[]>>(EntityType.GlobalKeyVaults, builder => {
        const rest = builder.rest('/key-vaults');

        return {
            remoteValue: builder.all(GlobalKeyVaults_Read, () => rest.getAll()),
        };
    })
);

startEntityStore(useGlobalKeyVaultStore, keyVaultSubscription);
